import { Box, TextField } from "@mui/material";
import React from "react";
interface ISearhBar {
  onSearch: (searchText: string) => void;
  title?: string;
  value: string;
  placeholder?: string;
  className?: string;
}

const SearchBar: React.FC<ISearhBar> = ({
  onSearch,
  value,
  className,
  placeholder,
  title,
}) => {
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(event.target.value);
  };
  return (
    <TextField
      variant="outlined"
      size="small"
      placeholder={placeholder}
      value={value}
      title={title}
      onChange={handleSearchChange}
      className={`search-bar ${className}`}
      slotProps={{
        input: {
          startAdornment: (
            <span className="material-symbols-outlined primary-color search-icon">
              search
            </span>
          ),
        },
      }}
    />
  );
};

export default SearchBar;
